// This file gets any necessary env variables, as well as sets any other necessary variables.
// Note: There is a test version of this file within /test - if you add a new variable here be sure to add it there as well
export const baseUrl = process.env.MIX_APP_URL;
export const apiPrefix = '/api';
export const rollbarToken = process.env.MIX_ROLLBAR_JS_TOKEN;
export const appEnv = process.env.MIX_APP_ENV;
export const stripePublicKey = process.env.MIX_STRIPE_KEY;
export const resultsPerPage = 10;
export const patientsPDFFolder = '/storage/patient_pdfs';
